export default () => ({
    lastmessages: null
})